export default () => ({
    lastmessages: null
})